import { cn } from '@/shared/utilities';
import { memo } from 'react';
import type { Message } from '../../models/message';
import { EmojiAction } from './emoij-action';
import { ReplyAction } from './reply-action';

interface MessageQuickActionsProps {
  message?: Message;
  isOwn: boolean;
  className?: string;
}

export const MessageQuickActions = memo<MessageQuickActionsProps>(({ message, className }) => {
  if (!message || message.isRevoked) return null;
  return (
    <div
      className={cn(
        'mex:flex mex:items-center mex:gap-1 mex:opacity-0 mex:transition-opacity mex:duration-200 mex:group-hover:opacity-100',
        !message.hideName && 'mex:mt-7',
        className
      )}
    >
      <ReplyAction message={message} />
      <EmojiAction message={message} />
    </div>
  );
});

MessageQuickActions.displayName = 'MessageQuickActions';
